import { render, staticRenderFns } from "./Cancelation.vue?vue&type=template&id=21827430&scoped=true"
import script from "./Cancelation.vue?vue&type=script&lang=js"
export * from "./Cancelation.vue?vue&type=script&lang=js"
import style0 from "./Cancelation.vue?vue&type=style&index=0&id=21827430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21827430",
  null
  
)

export default component.exports